<div class="accordions-container" *ngIf="formGroup">
  <div class="accordion-container" [formGroup]="formGroup">
    <div>
      <div class="body">
        <div>
          <date-picker
            id="dpStartTime"
            name="StartTime"
            [group]="formGroup"
            [label]="'ClientApp.FrontOffice.Messaging.ListMessage.FromDate' | translate"
            [required]="false"
            textType="date"
            [disabled]="false">
          </date-picker>
        </div>
        <div>
          <date-picker
            id="dpEndTime"
            name="EndTime"
            [group]="formGroup"
            [label]="'ClientApp.FrontOffice.Messaging.ListMessage.ToDate' | translate"
            [required]="false"
            textType="date"
            [disabled]="false">
          </date-picker>
        </div>
        <div>
          <ssg-input
            name="To"
            [label]="'ClientApp.FrontOffice.Messaging.ListMessage.ReceiveNumber' | translate"
            [group]="formGroup"
            [required]="false"
            textType="text"
            [disabled]="false">
          </ssg-input>
        </div>
      </div>
    </div>
    <div class="list-box">
      <div class="titleheader" *ngIf="isMultiBranch">
        <div class="title" (click)="setSelectedFilter('BranchList')">
          <span>{{ "ClientApp.FrontOffice.Messaging.ListMessage.Branch" | translate }}</span>
          <i class="icon-chevron-right" [class.icon-chevron-up]="selected === 'BranchList'"></i>
        </div>
        <div *ngIf="selected === 'BranchList'" class="content">
          <ssg-checkbox-list
            name="BranchList"
            id="chbBranchList"
            [group]="formGroup"
            apiName="Branch/ReadLookUp"
            textFieldName="Title"
            valueFieldName="Id"
            [required]="false"
            [disabled]="false">
          </ssg-checkbox-list>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('State')">
          <span>{{ "ClientApp.FrontOffice.Messaging.ListMessage.State" | translate }}</span>
          <i class="icon-chevron-right" [class.icon-chevron-up]="selected === 'State'"></i>
        </div>
        <div *ngIf="selected === 'State'" class="content">
          <ssg-checkbox-list
            name="StatusList"
            id="chbStatusList"
            [group]="formGroup"
            apiName="Lookup"
            systemName="SALE"
            category="MessageStatus"
            textFieldName="Title"
            valueFieldName="Id"
            [required]="false"
            [disabled]="false">
          </ssg-checkbox-list>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('MessageStatus')">
          <span>{{ "ClientApp.FrontOffice.Messaging.ListMessage.MessageType" | translate }}</span>
          <i class="icon-chevron-right" [class.icon-chevron-up]="selected === 'MessageStatus'"></i>
        </div>
        <div *ngIf="selected === 'MessageStatus'" class="content">
          <ssg-checkbox-list
            name="TypeList"
            id="chbTypeList"
            apiName="Lookup"
            systemName="SALE"
            category="MessageType"
            textFieldName="Title"
            valueFieldName="Id"
            [required]="false"
            [disabled]="false"
            [group]="formGroup">
          </ssg-checkbox-list>
        </div>
      </div>
    </div>
    <div class="ppplayFilter">
      <ssg-button
        icon="icon-filter_alt-o"
        (click)="ApplayFilter()"
        class="login-btn marginbutton"
        [label]="'ClientApp.FrontOffice.Messaging.ListMessage.FilterAccept' | translate"
        size="large"
        appearance="flat">
      </ssg-button>
    </div>
  </div>
  <div class="smsbox h-100">
    <div class="h-100 sms-list">
      <div class="h-100">
        <div *ngIf="columns !== undefined && columns.length > 0" class="h-100">
          <kgrid
            [label]="label"
            [name]="apiName"
            [areaName]="areaName"
            [columns]="columns"
            [noToolBar]="true"
            [gridViewData]="currentData"
            [isEdit]="false"
            (onDataStateChanged)="onPageChanged($event)"
            [isAdd]="false"
            [isDelete]="false"
            [isMulti]="false">
          </kgrid>
        </div>
      </div>
    </div>
  </div>
</div>
